import { render, staticRenderFns } from "./FranchisesView.vue?vue&type=template&id=36bcd5fe&scoped=true"
import script from "./FranchisesView.vue?vue&type=script&lang=ts"
export * from "./FranchisesView.vue?vue&type=script&lang=ts"
import style0 from "./FranchisesView.vue?vue&type=style&index=0&id=36bcd5fe&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36bcd5fe",
  null
  
)

export default component.exports